'use strict';

/**
 * Base Colors.
 */ const colors = {
    transparent: 'transparent',
    current: 'currentColor',
    white: '#ffffff',
    black: {
        DEFAULT: '#000000',
        10: '#F9F9FC',
        25: '#F5F5F8',
        50: '#F1F0F5',
        75: '#E5E4ED',
        90: '#DAD8E2',
        100: '#C7C5D1',
        200: '#A7A3B5',
        300: '#8A849C',
        400: '#6B6580',
        500: '#4E4763',
        600: '#3D3652',
        700: '#29233B',
        800: '#1F1A30',
        900: '#111827'
    },
    violet: {
        25: '#FEF9FE',
        50: '#FEF5FE',
        75: '#FDEDFE',
        90: '#F9D6FC',
        100: '#F6C1FB',
        200: '#F3ACFA',
        300: '#EF8DF8',
        400: '#E386EC',
        500: '#CC4BD9',
        600: '#BB1DCA',
        700: '#9E06AD',
        800: '#790285',
        900: '#510958'
    },
    purple: {
        50: '#F6F2FF',
        75: '#F1EBFF',
        100: '#CCB6FC',
        200: '#B090F5',
        300: '#9F72FF',
        400: '#8656EF',
        800: '#342552',
        900: '#291E40'
    },
    blue: {
        25: '#F8FCFF',
        50: '#F1F8FF',
        75: '#E1F2FF',
        90: '#B5E1FF',
        100: '#90D2FF',
        200: '#5FBFFF',
        300: '#1AA3FF',
        400: '#1894E8',
        500: '#007ACD',
        600: '#0073C3',
        700: '#005DA4',
        800: '#19354D',
        900: '#142A47'
    },
    green: {
        25: '#F8FFFD',
        50: '#EEFFFA',
        75: '#E2FDF2',
        90: '#B0F7D3',
        100: '#7EF1B3',
        200: '#62E2A4',
        300: '#1ED67D',
        400: '#26BC62',
        500: '#0B9C4A',
        600: '#008339',
        700: '#00642B',
        800: '#1B402B',
        900: '#16251D'
    },
    yellow: {
        25: '#FFFCF2',
        50: '#FFF9E1',
        75: '#FEF3C7',
        90: '#FFECA2',
        100: '#FFE27C',
        200: '#FED74D',
        300: '#F8C23A',
        400: '#E7A600',
        500: '#CE701A',
        600: '#B73700',
        700: '#9F370B',
        800: '#402E26',
        900: '#2C1911'
    },
    orange: {
        25: '#FFFCF7',
        50: '#FFF7EA',
        75: '#FFF5DF',
        90: '#FEF2D4',
        100: '#FCE7A7',
        200: '#FFCD83',
        300: '#FFA876',
        400: '#FF8368',
        500: '#E46630'
    },
    red: {
        25: '#FFFAFB',
        50: '#FFF6F8',
        75: '#FFEAEF',
        90: '#FFDEE6',
        100: '#FFD2DD',
        200: '#FF899E',
        300: '#FF6678',
        400: '#F05C6B',
        500: '#D42C3D',
        600: '#BC0016',
        700: '#9B0013',
        800: '#66141D',
        900: '#53151D'
    },
    mauve: {
        75: '#F3E7EE',
        800: '#541C3D'
    },
    teal: {
        75: '#D6F4FE',
        300: '#68D7FA',
        800: '#0C3E4E',
        900: '#092D39'
    }
};

exports.colors = colors;
//# sourceMappingURL=colors.js.map
